import { storage } from './redux-storage';

export const appConfigPersistConfig = {
    key: 'appConfig',
    storage,
};
